import { takeEvery, put } from "redux-saga/effects";
import { request } from "../../../api/Service";
import { getErrorMessage } from "../../../components/utils/errorHandler";
import { toast } from "react-toastify";
import history from "../../../router/browserrouter";

export default function* watcherSaveOrderForCheckOutSaga() {
  yield takeEvery("SAVE_ORDERS_FOR_CHECKOUT", workerSaga);
}

function* workerSaga(action) {
  try {
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    var payload = {};
    var formatUrl = "api/Admin/sales-order";
    yield request("post", action.payload, formatUrl).then((response) => {
      payload = response;
    });

    toast.success("Successful")
    yield put({ type: "DISPLAY_LOADER", payload: payload });
    history.push("/checkout");
  } catch (e) {
    console.log(e);
    console.log("product-saga", e);
    console.log("product-saga", e.response);
    yield put({ type: "LOADING_BUTTON_SPINNER" });
    const errorMessage = getErrorMessage(e.response);
    toast.error(errorMessage);
    yield put({ type: "API_ERRORED", payload: e });
    yield put({ type: "DISPLAY_LOADER", payload: payload });
  }
}
